<template>
    <div>
        <template v-if="!isLoading">
            <b-row>
                <b-col lg="7">
                    <b-row class="mb-2">
                        <b-col lg="2" md="6">
                            <label class="font-weight-bold pt-0 mb-0">Dispatch No.:</label>
                        </b-col>
                        <b-col>
                            <label class="numFont mb-0">{{ dispatchNo }}</label>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="2" md="6">
                            <label class="font-weight-bold pt-0 mb-0">Area:</label>
                        </b-col>
                        <b-col>
                            <label class="numFont mb-0">{{ areaDestination }}</label>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col v-if="isClassified">
                    <a href="#" class="text-primary" @click.prevent="openDocumentsModal()">
                        View Documents
                    </a>
                </b-col>
            </b-row>

            <hr />

            <div class="asset-type-wrapper">
                <template v-for="(asset, index) in row.item.assets">
                    <b-row :key="index + 'row1'">
                        <b-col lg="7">
                            <b-row class="mb-4 align-items-center" :key="index">
                                <b-col lg="2" md="6">
                                    <label class="font-weight-bold pt-0 mb-0">Asset Type:</label>
                                </b-col>
                                <b-col>
                                    <label class="mb-0">{{ asset.assetType }}</label>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-row :key="index + 'row2'" class="condition-wrapper">
                        <b-col xl="4" lg="6" md="6" class="d-flex flex-column align-self-center">
                            <b-form-group class="mb-2">
                                <div class="d-flex align-items-center justify-content-center gap-2">
                                    <b-col lg="4" class="text-center">
                                        <label class="font-weight-bold mb-0">Condition</label>
                                    </b-col>
                                    <b-col lg="4" class="text-center">
                                        <label class="font-weight-bold mb-0">Quantity</label>
                                    </b-col>
                                </div>
                            </b-form-group>

                            <template v-if="isClassified">
                                <b-form-group class="mb-2"
                                    v-for="(label, key) in conditionData(asset, index).paginatedLabels"
                                    :key="key + 'conditions'">
                                    <div class="d-flex align-items-center justify-content-center gap-2">
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">{{ label }}</label>
                                        </b-col>
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">
                                                {{ conditionData(asset, index).paginatedValues[key] }}
                                            </label>
                                        </b-col>
                                    </div>
                                </b-form-group>
                                <b-form-group class="mt-5">
                                    <div class="d-flex align-items-center justify-content-center gap-2">
                                        <b-col>
                                            <span class="total-display">
                                                Total: {{ conditionData(asset, index).total }}
                                            </span>
                                        </b-col>
                                        <b-col>
                                            <b-pagination align="right" :total-rows="conditionData(asset, index).total"
                                                :per-page="perPage" v-model="currentPage[index]" :limit="1"
                                                class="my-0" />
                                        </b-col>
                                    </div>
                                </b-form-group>
                            </template>
                            <template v-else>
                                <b-form-group class="mb-2">
                                    <div class="d-flex align-items-center justify-content-center gap-2">
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">Good</label>
                                        </b-col>
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">0</label>
                                        </b-col>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center gap-2">
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">Damaged</label>
                                        </b-col>
                                        <b-col lg="4" class="text-center">
                                            <label class="mb-0">0</label>
                                        </b-col>
                                    </div>
                                </b-form-group>
                                <b-form-group class="mt-5">
                                    <div class="d-flex align-items-center justify-content-center gap-2">
                                        <b-col>
                                            <span class="total-display">
                                                Total: 2
                                            </span>
                                        </b-col>
                                        <b-col>
                                            <b-pagination align="right" :total-rows="2" :per-page="2" :limit="1"
                                                class="my-0" />
                                        </b-col>
                                    </div>
                                </b-form-group>
                            </template>
                        </b-col>

                        <b-col xl="8" lg="6" md="6" v-if="isClassified">
                            <AssetConditionsChart :data="conditionData(asset, index).values"
                                :labels="conditionData(asset, index).conditions" />
                        </b-col>
                    </b-row>

                    <b-row class="mb-2" :key="index + 'total'">
                        <b-col lg="auto">
                            <small class="pt-0 mb-0">Total Assets:</small>
                        </b-col>
                        <b-col>
                            <small class="mb-0">
                                {{ row.item.status === 'Received'
                                    ? asset.actualQuantity :
                                    asset.expectedQuantity }}
                            </small>
                        </b-col>
                    </b-row>

                    <hr v-if="index !== row.item.assets.length - 1" :key="index + 'hr'" />
                </template>
            </div>
        </template>
    </div>
</template>

<script>
// Utils
import { DispatchUtil } from '@/utils/dispatchUtil';

// DAO
import classificationDAO from '@/database/classifications';

// Others
import EventBus from '@/shared/event-bus';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _ from 'lodash';

export default {
    name: 'dispatch-details-asset-view',
    components: {
        Loading,
        AssetConditionsChart: () => import("@/views/commons/charts/AssetConditionsChart"),
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
        allClassifications: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            classification: {},

            currentPage: [],
            totalRows: [],
            perPage: 2,

            isLoading: true,
        }
    },
    computed: {
        dispatchNo() {
            let dispatch = this.row.item ? this.row.item : {};
            return dispatch.dispatchNo ? dispatch.dispatchNo : '';
        },
        areaDestination() {
            let destination = this.row.item && this.row.item.destination ? this.row.item.destination : null;
            return destination ? DispatchUtil.getCompanyLocationDisplay(destination) : '';
        },
        totalAssetsClassified() {
            let dispatch = this.row.item ? this.row.item : {};
            return dispatch.Received ? dispatch.Received : 0;
        },
        isClassified() {
            let dispatch = this.row.item ? this.row.item : {};
            return dispatch.isClassified ? dispatch.isClassified : false;
        },
    },
    mounted() {
        EventBus.$on('onLoadAssetsClassification', async () => {
            this.updateTable();

            const filter = {
                id: this.row.item.id,
                assetTypeId: this.row.item.assets[0].assetTypeId,
                dispatchId: this.row.item.id,
            }

            this.classification = await classificationDAO.getClassificationByAssetType(filter);
        });
    },
    methods: {
        openDocumentsModal() {
            EventBus.$emit('onUpdateClassificationDocumentsView', this.classification);
            this.$bvModal.show(`classification-documents-view-${this.row.item.id}`);
        },
        conditionData(asset, index) {
            const assetConditions = _.get(asset, 'conditions', {});
            const conditions = _.map(assetConditions, (value, key) => ({
                condition: key,
                quantity: value,
            }));

            // Separate Good and Damaged first
            const goodAndDamaged = _.filter(conditions, c =>
                c.condition === 'Good' || c.condition === 'Damaged'
            );

            // Get the rest and sort them alphabetically by condition
            const otherConditions = _.filter(conditions, c =>
                c.condition !== 'Good' && c.condition !== 'Damaged'
            );
            const sortedOthers = _.sortBy(otherConditions, 'condition');

            // Combine: Good + Damaged + Sorted Others
            const orderedConditions = [...goodAndDamaged, ...sortedOthers];

            // Map values and labels in this new order
            const values = _.map(orderedConditions, c => _.get(assetConditions, c.condition));
            const labels = _.map(orderedConditions, 'condition');

            const currentPage = this.currentPage[index] || 1;
            const start = (currentPage - 1) * this.perPage;
            const end = start + this.perPage;

            return {
                values,
                conditions: labels,
                paginatedValues: values.slice(start, end),
                paginatedLabels: labels.slice(start, end),
                total: labels.length,
            };
        },
        updateTable() {
            this.isLoading = true;

            let item = this.row.item;

            if (!_.isEmpty(item.assets)) {
                _.forEach(item.assets, (asset) => {
                    this.totalRows.push(asset.conditions ? Object.values(asset.conditions).length : 2);
                    this.currentPage.push(1);
                });
            }

            this.isLoading = false;
        },
    },
}
</script>

<style scoped>
.asset-type-wrapper {
    overflow-y: auto;
    overflow-x: hidden;

    @media (min-width: 768px) {
        max-height: 20vh;
    }

    @media (min-width: 992px) {
        max-height: 35vh;
    }

    @media (min-width: 1200px) {
        max-height: 50vh;
    }

    @media (min-width: 1400px) {
        max-height: 55vh;
    }
}

.condition-wrapper {
    min-height: 250px;
}
</style>